<template>
    <div class="task-notice">
        <el-popover
            placement="bottom"
            :width="850"
            trigger="click"
            @show="showPopover"
        >
            <template #reference>
                <div class="icon-container" :class="{'has-dot': hasNewMsg}">
                    <el-icon><UploadFilled /></el-icon>
                </div>
            </template>
            <div>
                <b-table
                    ref="TTable"
                    v-el-table-infinite-scroll="load"
                    v-loading="tableLoading"
                    class="scroll-table"
                    :infinite-scroll-disabled="false"
                    :table="table"
                    :show-summary="false"
                    :columns="tableColumns"
                    :is-show-pagination="false"
                >
                    <template #empty>
                        <no-data v-loading="tableLoading" />
                    </template>
                </b-table>
            </div>
        </el-popover>
    </div>
</template>
<script setup lang="ts">
import { ref, onMounted, reactive, computed, onUnmounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { default as vElTableInfiniteScroll } from '@/directives/el-table-scroll';
// import { default as vElTableInfiniteScroll } from 'el-table-infinite-scroll';
import { fetchChangeBarginStatus } from '@/apis/accounts';
import { fetchFollowUpStatus } from '@/apis/lead';
import { fetchJobList } from '@/apis/common';
import noData from '@/components/noData/index.vue';
import BTable from '@/components/table/index.vue';
import Status from './status.vue';
import { useI18n } from 'vue-i18n';
import { defineUserStore } from '@/stores/user';
const userStore = defineUserStore();
const props = defineProps({
    type: {
        type: String,
        default: () => ''
    },
    ids: {
        type: Array,
        default: () => []
    }
});
let timmer:any = null;
const tableColumns = computed(() => {
    return [
        {
            prop: 'module',
            label: 'common.module',
            renderHeader: () => 'common.module',
            width: 80
        },
        {
            prop: 'type',
            label: 'common.type',
            renderHeader: () => 'common.type',
            width: 120,
            format: (row) => {
                return row && row.type ? i18n.t(`btn.${row.type}`) : '';
            }
        },
        {
            prop: 'file_name',
            label: 'common.name',
            renderHeader: () => 'common.name',
            width: 200
        },
        {
            prop: 'status',
            label: 'settings.status',
            renderHeader: () => 'settings.status',
            width: 150,
            render: () => "status",
            component: Status,
        },
        {
            prop: 'created_time',
            label: 'settings.created_at',
            renderHeader: () => 'settings.created_at',
        }
    ];
});
const tableLoading = ref(false);
const table = reactive({
    data: [],
    border: true,
    firstColumn: {},
    total: 0,
    maxHeight: 190,
    pageSize: 20,
    currentPage: 1
});
const compareData: any = ref([]);
const hasNewMsg = computed(() => {
    return userStore.fileJobTip;

});
const scrollDisabled = ref(false);
const load = () => {
    if (scrollDisabled.value) return;
    table.currentPage++;
    if (table.currentPage <= Math.ceil(table.total / table.pageSize)) {
        getTableData();
    }
    if (table.currentPage === Math.ceil(table.total / table.pageSize)) {
        scrollDisabled.value = true;
    }
};
const i18n = useI18n();
const emits = defineEmits(['confirm']);
const handlePageChange = (page: number) => {};
const handlePageSizeChange = (pageSize: number) => {};
const getTableData = async (isReset?: Boolean) => {
    // tableLoading.value = true;
    if (isReset) {
        table.currentPage = 1;
    }
    const { currentPage, pageSize } = table;
    const params = {
        page_num: currentPage,
        page_size: pageSize,
    };
    try {
        const res = await fetchJobList(params);
        if (res.errno === 0) {
            const datas = res?.data || {};
            if (currentPage === 1) {
                compareData.value = datas.list || [];
                table.data = datas.list || [];
            } else {
                table.data = table.data.concat(datas.list || []);
            }
            table.total = datas.total_page_size;
        } else {
            table.data = [];
            table.total = 0;
        }
        // emits('getTableDataList', table.data);
    } catch (error) {
        console.log('error');
    } finally {
    }
    tableLoading.value = false;
};
const getCompareData = async () => {
    const { pageSize } = table;
    const params = {
        page_num: 1,
        page_size: pageSize,
    };
    try {
        const res = await fetchJobList(params);
        if (res.errno === 0) {
            const datas = res?.data || {};
            compareData.value = datas.list || [];
            const nowData = compareData.value.map((item: any) => item.id + item.status).join('');
            const tableDatas = table.data.slice(0, table.pageSize).map((item: any) => item.id + item.status).join('');
            userStore.setFileJobTip(tableDatas === '' ? false : nowData !== tableDatas);
            table.currentPage = 1;
            table.data = datas.list || [];
            scrollDisabled.value = false;
        } else {

        }
        // emits('getTableDataList', table.data);
    } catch (error) {
        console.log('error');
    } finally {
    }
};
const showPopover = () => {
    tableLoading.value = true;
    table.currentPage = 1;
    userStore.setFileJobTip(false);
    getTableData();
}
const handleTimmer = () => {
    const isTestHost = window.location.host === 'jp01-pop-uts3-plt08.jp01.baidu.com:8869';
    if (!timmer) {
        timmer = setInterval(getCompareData, isTestHost ? 30 * 1000 : 10 * 1000);
    }
};
const handleDocumentVisible = () => {
    if (document.visibilityState === 'visible') {
        handleTimmer();
    } else {
        clearInterval(timmer);
        timmer = null;
    }
};
onMounted(() => {
    // getTableData(true);
    handleTimmer();
    document.addEventListener('visibilitychange', handleDocumentVisible);
});
onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleDocumentVisible);
    clearInterval(timmer);
    timmer = null;
});
</script>
<style scoped lang="scss">
    .icon-container {
        cursor: pointer;
        height: 32px;
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #5d6171;
        &.has-dot {
            position: relative;
            &::after {
                position: absolute;
                top: 0;
                right: 0;
                content: '';
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: var(--el-color-danger);
            }
        }
    }
</style>
